<template>
  <v-row>
    <v-col cols="12" sm="10" md="10" lg="8" class="px-md-11 mx-auto">
      <v-card :height="$vuetify.breakpoint.smAndUp ? 654 : ''" rounded="lg">
        <v-container fluid fill-height class="py-0">
          <v-row>
            <v-col
              cols="5"
              class="pa-0 pr-0 d-none d-md-flex cabin-truck-image-wrapper"
            >
              <!-- <v-img
                src="../../assets/cabin-truck.png"
                class="rounded-l-lg"
              ></v-img> -->
              <div class="cabin-truck-image"></div>
            </v-col>
            <v-col class="col-12 col-md-7 px-11 px-xl-16" align-self="center">
              <div class="text-center">
                <SvgIcon
                  class="primary--text"
                  width="134"
                  height="110"
                  iconType="icon_envelope"
                />
                <h1 class="secondary--text font-weight-black text-h4 mt-3">
                  {{ $t('portal.register.welcome_mail_resend.labels.title') }}
                </h1>
                <p class="secondary--text mt-6">
                  {{
                    $t('portal.register.welcome_mail_resend.labels.subtitle')
                  }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { SvgLogo, SvgIcon, magentaOAuth } from '@leapsight/styleguide'

export default {
  name: 'WelcomeMailResend',
  components: { SvgLogo, SvgIcon },
  props: {},
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {}
  // Lifecycles
}
</script>

<style lang="scss" scoped>
.light-grey {
  color: var(--light-grey-blue);
}
.divider {
  background-color: var(--dark-hot-pink);
  height: 3px;
  max-height: 3px;
}
.container.fill-height {
  align-items: initial !important;
}
.cabin-truck-image-wrapper {
  position: relative;
  .cabin-truck-image {
    background-image: url('../../assets/cabin-truck.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    background-position: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}
</style>
